export default __webpack_public_path__ + "static/media/works-for-me.439179b5.gif";